/**
 * Page Header Component
 * 
 * Standardized header for static content pages.
 * Provides consistent title and subtitle styling.
 */

import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  hero?: boolean; // Use hero styling like FAQ page
  children?: ReactNode; // For additional content like TL;DR
}

export default function PageHeader({ title, subtitle, hero = false, children }: PageHeaderProps) {
  if (hero) {
    // FAQ-style hero section
    return (
      <>
        <div className="bg-oro-surface border-b border-oro-border py-16 px-4 -mx-4 -mt-16 mb-16">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold text-text-primary mb-4">
              {title}
            </h1>
            {subtitle && (
              <p className="text-text-secondary text-lg">
                {subtitle}
              </p>
            )}
          </div>
        </div>
        {children}
      </>
    );
  }

  // Standard header (About/Terms/Privacy style)
  return (
    <div className="text-center mb-8">
      <h1 className="text-3xl font-bold text-text-primary mb-3">
        {title}
      </h1>
      {subtitle && (
        <p className="text-text-secondary">
          {subtitle}
        </p>
      )}
      {children}
    </div>
  );
}